import axios from 'axios';
import request from '../utils/axios/request';
import { PaginationContent } from '../utils/types/pagination';
import { Query } from '../utils/types/query';
import { IMaterial } from './Material.service';
import { IYard } from './Yard.service';
import { IClient, QueryClient } from './Client.service';

export interface IMaintenanceType {
	id?: string;
	description: string;
	client?: Partial<IClient>;
}

export interface IMaintenance {
	id?: number;
	enviarEmail?: boolean;
	maintenanceType?: IMaintenanceType;
	yard: Partial<IYard>;
	description: string;
	date: Date;
	hh?: string;
	voltage?: string;
	size?: string;
	manufactory?: string;
	container?: string;
	block?: string;
	batch?: string;
	place?: string;
	images?: string[];
	imgFiles?: File[];
	materials: (Partial<IMaterial> & { quantity: string })[];
	actions?: any;
}

export interface MaintenanceR {
	checked: boolean;
	id: number;
	date: Date;
	hh: string;
	voltage: string;
	size: string;
	manufactory: string;
	container: string;
	actions: any;
}

abstract class MaintenanceService {
	static async delete(ids: number[]) {
		if (!ids.length || ids.some((id) => !Number.isInteger(id) || id <= 0)) {
			throw new Error('alert.error.generic');
		}

		await request('/maintenances', 'delete', { data: { ids } });
	}

	static async getAll(
		params: Query
	): Promise<PaginationContent<IMaintenance> | undefined> {
		let isActive;
		if (params.isActive && Number(params.isActive) > -1) {
			isActive = params.isActive;
		}

		try {
			const response: PaginationContent<IMaintenance> = await request(
				'/maintenances',
				'get',
				{
					params: { ...params, isActive },
				}
			);
			return response;
		} catch (error: any) {}
	}

	static async create(
		content: IMaintenance,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		try {
			const { yard, materials, maintenanceType, imgFiles, hh, ...data } =
				content;

			const materialsDto = materials.map((material) => ({
				id_material: material.id,
				quantity: Number(material.quantity),
			}));

			const formData = new FormData();
			formData.append(
				'data',
				JSON.stringify({
					...data,
					id_yard: yard.id,
					id_maintenance_type: maintenanceType?.id,
					materials: materialsDto,
					hh: hh !== '' ? hh : undefined,
				})
			);

			if (imgFiles && imgFiles.length > 0) {
				imgFiles.forEach((image) => {
					const fileName = `maintenance_${(image as File).name}`;
					if (image instanceof File) {
						const modifiedFile = new File([image], fileName, {
							type: image.type,
						});
						formData.append('images', modifiedFile);
					}
				});
			}

			const response = await request('/maintenances', 'post', {
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}

	static async getAllMaintenanceType(): Promise<
		IMaintenanceType[] | undefined
	> {
		try {
			const response: IMaintenanceType[] = await request(
				'/maintenances/type',
				'get'
			);
			return response;
		} catch (error: any) {}
	}

	static async createMaintenanceType(
		content: IMaintenanceType,
		setError: React.Dispatch<React.SetStateAction<string>>
	) {
		const { client, ...data } = content;

		try {
			const response = await request('/maintenances/type', 'post', {
				data: { ...data, idClient: client?.id },
			});
			return response;
		} catch (error) {
			setError('alert.error.generic');
		}
	}

	static async getAllAuditory(
		params: QueryClient,
		yardId?: number,
		date?: Date
	): Promise<PaginationContent<MaintenanceR> | undefined> {
		try {
			const response: PaginationContent<MaintenanceR> = await request(
				'/maintenances/auditory',
				'get',
				{
					params: {
						yardId,
						date: date ? date.toISOString() : undefined,
						...params,
					},
				}
			);
			return response;
		} catch (error: any) {}
	}
}

export default MaintenanceService;
